import React from 'react';
import { Check, Info, AlertTriangle, CheckCircle, X } from 'lucide-react';
import { Notification } from '../../types/notification';
import { formatDate } from '../../utils/formatters';

interface NotificationItemProps {
  notification: Notification;
  onMarkAsRead: (id: string) => void;
}

export default function NotificationItem({ notification, onMarkAsRead }: NotificationItemProps) {
  const getIcon = (type: string) => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'warning':
        return <AlertTriangle className="w-5 h-5 text-yellow-500" />;
      case 'error':
        return <AlertTriangle className="w-5 h-5 text-red-500" />;
      default:
        return <Info className="w-5 h-5 text-blue-500" />;
    }
  };

  const getBackgroundColor = (type: string) => {
    switch (type) {
      case 'success':
        return 'bg-green-50';
      case 'warning':
        return 'bg-yellow-50';
      case 'error':
        return 'bg-red-50';
      default:
        return 'bg-blue-50';
    }
  };

  return (
    <div className={`p-4 ${!notification.read ? getBackgroundColor(notification.type) : ''} hover:bg-gray-50 transition-colors`}>
      <div className="flex items-start space-x-3">
        {getIcon(notification.type)}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between">
            <p className={`text-sm font-medium ${!notification.read ? 'text-gray-900' : 'text-gray-600'}`}>
              {notification.title}
            </p>
            <button
              onClick={() => onMarkAsRead(notification.id)}
              className="ml-2 text-gray-400 hover:text-gray-600"
            >
              {!notification.read ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
            </button>
          </div>
          <p className="mt-1 text-sm text-gray-600">
            {notification.message}
          </p>
          <p className="mt-1 text-xs text-gray-500">
            {formatDate(notification.timestamp)}
          </p>
        </div>
      </div>
    </div>
  );
}